// extracted by mini-css-extract-plugin
export default {"sapcnqr-icon-button":"sapcnqr-icon-button-c58236","sapcnqr-icon-button--lg":"sapcnqr-icon-button--lg-d6b0dd","sapcnqr-icon-button--wide":"sapcnqr-icon-button--wide-b5b0fc"};